const normalizeSaleOrderSearchText = (value) =>
  value === null || value === undefined
    ? ""
    : String(value).trim().replace(/\s+/g, " ").toLocaleLowerCase();

export const matchesSaleOrderSearch = (order, searchText) => {
  const normalizedSearchText = normalizeSaleOrderSearchText(searchText);
  if (!normalizedSearchText) return true;

  const firstName = order && order.firstname;
  const lastName = order && order.lastname;
  const fullName = [firstName, lastName].filter(Boolean).join(" ");
  const itemSerialNumbers = Array.isArray(order && order.items)
    ? order.items.reduce(
        (serialNumbers, item) =>
          serialNumbers.concat([
            item && item.productSn,
            item && item.serialNumber,
          ]),
        [],
      )
    : [];

  return [
    order && order.hn,
    firstName,
    lastName,
    fullName,
    order && order.serialNumber,
    ...itemSerialNumbers,
  ].some((value) =>
    normalizeSaleOrderSearchText(value).includes(normalizedSearchText),
  );
};

export const filterSaleOrders = (orders, searchText) =>
  (Array.isArray(orders) ? orders : []).filter((order) =>
    matchesSaleOrderSearch(order, searchText),
  );
